import { TYPE_REDUSER } from "../../utils/constants";
import { PROPERTY_LABELS, PLAYCANVAS_PROP_TO_SECTION_ID, PLAYCANVAS_IMAGE_MAP } from "../../utils/playcanvasConfig";

const initialState = {
  settings: [],
  showSettingGroupId: null,
  showSettingGroupIndex: null,
  showSettingGroupInfo: null,
};

const Settings = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_REDUSER.SELECT_COLOR_PARAMS:
      const sectionsId = action.payload.paramsGroupId;

      const sectionsActive = state.settings.find(
        (item) => item.id === sectionsId
      );
      sectionsActive.activeId = action.payload.colorId;
      
      sectionsActive.values?.map((setting) => {
        if (setting.id === sectionsActive.activeId) {
          sectionsActive.infoActiveElement = setting;
          return true;
        }
        return false;
      });

      return {
        ...state,
      };

    case TYPE_REDUSER.SHOW_PARAMETER_GROUP:
      const paramsGroupId = action.payload;
      const paramGroupActive = state.settings.find(
        (item) => item.id === paramsGroupId
      );

      let activeIndexSections = null;
      state.settings.map((item, index) => {
        if (item.id === paramsGroupId) {
          activeIndexSections = index;
          return true;
        }
        return false;
      });

      return {
        ...state,
        showSettingGroupId: paramsGroupId,
        showSettingGroupIndex: activeIndexSections,
        showSettingGroupInfo: paramGroupActive,
      };

    case TYPE_REDUSER.SET_SHARED_INFO:
      return {
        ...state,
        ...action.payload.metadata.Settings,
        initConfig: action.payload.variant
      }

    case TYPE_REDUSER.SET_ACTIVE_ITEM: {
      const { name: propKey, data: materialValue } = action.payload;
      // Find the section whose propertyKey matches
      const section = state.settings.find(s => s.propertyKey === propKey);
      if (!section) return state;

      const match = section.values.find(v => v.materialName === materialValue);
      if (!match || section.activeId === match.id) return state; // no change

      // Return new state with updated activeId / infoActiveElement
      return {
        ...state,
        settings: state.settings.map(s =>
          s.propertyKey === propKey
            ? { ...s, activeId: match.id, infoActiveElement: match }
            : s
        ),
      };
    }

    case TYPE_REDUSER.INIT_SETTINGS_FROM_API: {
      const { settings: apiSettings, boatType: apiBt } = action.payload;
      const firstApiId = apiSettings.length > 0 ? apiSettings[0].id : null;

      return {
        ...state,
        settings: apiSettings,
        boatType: apiBt,
        showSettingGroupId: firstApiId,
        showSettingGroupIndex: firstApiId ? 0 : null,
        showSettingGroupInfo: apiSettings[0] || null,
      };
    }

    case TYPE_REDUSER.INIT_PLAYCANVAS_SETTINGS: {
      const { config, availableOptions, boatType } = action.payload;

      // ── Побудова settings тільки для опцій поточної лодки ─────────────
      const materialKeys = Object.keys(availableOptions).filter(k => k !== 'boatType');
      const newSettings = [];

      for (const propKey of materialKeys) {
        const optEntry = availableOptions[propKey];

        // Беремо опції для конкретної лодки:
        // Якщо perBoat існує — використовуємо тільки опції для цієї лодки.
        // Якщо perBoat існує, але лодки немає в списку — пропускаємо (порожній масив).
        // Якщо perBoat немає — беремо глобальні options.
        const boatOptions = optEntry.perBoat
          ? (optEntry.perBoat[boatType] || [])
          : (optEntry.options || []);
        if (boatOptions.length === 0) continue; // ця лодка не підтримує цей параметр

        const sectionId = PLAYCANVAS_PROP_TO_SECTION_ID[propKey] || `playcanvas__${propKey}`;

        // Карта зображень Icon для цього атрибута
        const imageMap = PLAYCANVAS_IMAGE_MAP[propKey] || {};

        const values = boatOptions.map(opt => {
          const valId = `${propKey}__${opt.value}`;

          // Шукаємо зображення: спочатку точне значення, потім з підміною _ → пробіл і навпаки
          const imgUrl = imageMap[opt.value]
            || imageMap[opt.value.replace(/_/g, ' ')]
            || imageMap[opt.value.replace(/ /g, '_')]
            || null;

          // Людиночитабельне ім'я: label або value, завжди без підкреслень
          const displayName = (opt.label || opt.value).replace(/_/g, ' ');

          return {
            id: valId,
            name: displayName,
            materialName: opt.value,   // PlayCanvas value для setConfig
            propertyKey: propKey,      // PlayCanvas ключ для setConfig
            imgUrl,
            visible: true,
          };
        });

        // Поточне активне значення з конфігу PlayCanvas
        const currentValue = config[propKey] || null;
        const activeVal = values.find(v => v.materialName === currentValue) || values[0];

        newSettings.push({
          id: sectionId,
          name: PROPERTY_LABELS[propKey] || propKey,
          propertyKey: propKey,
          activeId: activeVal?.id || null,
          infoActiveElement: activeVal || null,
          values,
        });
      }

      // Скидаємо активну групу на першу (щоб не тримати застарілий id)
      const firstId = newSettings.length > 0 ? newSettings[0].id : null;

      return {
        ...state,
        settings: newSettings,
        boatType,
        showSettingGroupId: firstId,
        showSettingGroupIndex: firstId ? 0 : null,
        showSettingGroupInfo: newSettings[0] || null,
      };
    }

    default:
      return state;
  }
};

export default Settings;
